import React, { useState, useRef, useImperativeHandle } from 'react';
import * as Ui from './styles';
import InputSearch from '../InputSearch';
import { Selector } from '../../Selector';

/**
 * Componente de filtragem que utiliza-se de um seletor de tipos, para indicar
 * que a filtragem de ser aplicada a um tipo especificado, que pode ser um dataset, objeto, etc
 * @param {*} types
 * @param {*} placeholder
 * @param {*} onFilter
 */
function TypedSearch({
  types,
  placeholder,
  onChangeFilterKeywords,
}, ref) {
  // state
  const [type, setType] = useState(types && types[0].value);
  const [selectedIndex, setSelectedIndex] = useState(0);
  // refs
  const inputSearchRef = useRef();
  // props
  const dataSet = types && types.map((t) => ({ label: t.label, value: t.value }));
  const isTyped = types && true;

  // api para este componente
  useImperativeHandle(ref, () => ({
    clear: () => {
      setSelectedIndex(0);
      setType(types && types[0].value);
      if (inputSearchRef.current) inputSearchRef.current.clear();
    },
  }));

  /**
   * Callback executado quando os dados de filtragem sao alterados
   */
  function handleChangeFilterText(kwords) {
    if (isTyped && onChangeFilterKeywords) {
      onChangeFilterKeywords({ type, keywords: kwords });
    }
  }

  /**
   * Funcao callback quando o tipo de busca eh alterado
   */
  function handleChangeType(selectionData) {
    if (selectionData.length === 0) return;
    const newSelection = selectionData[0];
    setType(newSelection.value);
    const newSelectedIndex = dataSet.findIndex((item) => item.value === newSelection.value);
    setSelectedIndex(newSelectedIndex);
    if (inputSearchRef.current) inputSearchRef.current.clear();
  }

  return (
    <Ui.Container className="SelectableSearch-wrapper">
      {isTyped && (
        <Selector
          dark
          type="single"
          data={dataSet}
          initialSelectedIndexes={[selectedIndex]}
          onChange={handleChangeType}
          placeholder={placeholder}
        />
      )}
      <InputSearch
        ref={inputSearchRef}
        onChangeText={handleChangeFilterText}
        placeholder={placeholder}
      />
    </Ui.Container>
  );
}

export default React.forwardRef(TypedSearch);
